import { MonitoringToastsState } from './model'
import { ActionType, MonitoringToastsAction } from './actions'

export const initialState: MonitoringToastsState = {
  toastList: []
}

const reducer = (state: MonitoringToastsState = initialState, action: MonitoringToastsAction): MonitoringToastsState => {
  switch (action.type) {
    case ActionType.ChangeToasts:
      return {toastList: action.payload.toasts}

    default:
      return state
  }
}

export default reducer
